export default __webpack_public_path__ + "static/media/snd_00017.e97389b2.mp4";